import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import "./login.css";
import logo from "../../assets/img/ht-logo-login.svg";

function LoginPage() {
    const { login, idToken } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        console.log("LoginPage - Environment check:", {
            cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN,
            clientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
            hasLogin: typeof login === "function",
        });

        if (idToken) {
            navigate("/");
        } else {
            console.log("Calling login function...");
            try {
                login(); // This redirects to Cognito
            } catch (error) {
                console.error("Login error:", error);
            }
        }
    }, [idToken, login, navigate]);

    return (
        <div className="auth">
            <div className="auth-container">
                <div className="login-logo">
                    <img src={logo} className="logo" alt="Hoteltrader" />
                </div>
                <div className="login-title font-13">Client Portal</div>
                <p>Redirecting to authentication...</p>
            </div>
        </div>
    );
}

export default LoginPage;
